import {Configuration} from './js-openapi3-client-v3';


function conf(): Configuration {
  return new Configuration(
    {
      basePath: '/api' // proxied by local proxy.conf.js or node-server
    }
  );
}

export const OpenapiConfig: Configuration = conf();
